import {useEffect} from 'react'
import {useLayoutStoreInstance} from '../stores/LayoutStore'
import {
  useNavigateToSelectedComment,
  useNavigateToSelectedAnnotation,
  useOnCommentThreadDeletedFromDiffSummaries,
} from '../stores/selectors'

/**
 * Registers PullRequestStore diff navigation callbacks into the LayoutStore
 * so that layout-level components (e.g. side panels rendered from the header)
 * can trigger diff navigation when the files-changed route is active.
 *
 * Renders null — this is a side-effect-only component that must be rendered
 * inside both LayoutStoreProvider and PullRequestStoreProvider.
 */
export function DiffNavigationRegistrar() {
  const layoutStore = useLayoutStoreInstance()
  const navigateToComment = useNavigateToSelectedComment()
  const navigateToAnnotation = useNavigateToSelectedAnnotation()
  const onCommentThreadDeleted = useOnCommentThreadDeletedFromDiffSummaries()

  useEffect(() => {
    layoutStore.getState().layoutStoreActions.registerFilesChangedCallbacks({
      navigateToComment,
      navigateToAnnotation,
      onCommentThreadDeleted,
    })

    return () => {
      layoutStore.getState().layoutStoreActions.unregisterFilesChangedCallbacks()
    }
  }, [layoutStore, navigateToComment, navigateToAnnotation, onCommentThreadDeleted])

  return null
}
